import React, { useState, useEffect } from 'react';
import Button from '../../../../shared/components/Button';
import './ContextVariableForm.css';

const ContextVariableForm = ({ 
  initialData = null, 
  onSave, 
  onCancel, 
  isGlobalEnabled = true 
}) => {
  const [title, setTitle] = useState('');
  const [context, setContext] = useState('');
  const [isGlobal, setIsGlobal] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title || '');
      setContext(initialData.context || '');
      setIsGlobal(initialData.isGlobal || false);
    }
  }, [initialData]);

  const validate = () => {
    const newErrors = {};
    
    if (!title || !title.trim()) {
      newErrors.title = 'Title is required';
    } else if (title.length > 200) {
      newErrors.title = 'Title must be 200 characters or less';
    }
    
    if (!context || !context.trim()) {
      newErrors.context = 'Context is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }
    
    onSave({
      title: title.trim(),
      context: context.trim(),
      isGlobal: isGlobal && isGlobalEnabled,
    });
  };

  return (
    <form className="context-variable-form" onSubmit={handleSubmit}>
      <div className="form-input-group">
        <label className="form-label headline-medium">Title</label>
        <input
          type="text"
          className={`form-input ${errors.title ? 'error' : ''}`}
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            if (errors.title) {
              setErrors({ ...errors, title: null });
            }
          }}
          placeholder="Enter context variable title..."
          maxLength={200}
        />
        {errors.title && <div className="form-error">{errors.title}</div>}
      </div>

      <div className="form-input-group">
        <label className="form-label headline-medium">Context</label>
        <textarea
          className={`form-textarea ${errors.context ? 'error' : ''}`}
          value={context}
          onChange={(e) => {
            setContext(e.target.value);
            if (errors.context) {
              setErrors({ ...errors, context: null });
            }
          }}
          placeholder="Enter context text..."
          rows={6}
        />
        {errors.context && <div className="form-error">{errors.context}</div>}
      </div>

      {isGlobalEnabled && (
        <div className="form-input-group">
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              className="form-checkbox"
              checked={isGlobal}
              onChange={(e) => setIsGlobal(e.target.checked)}
            />
            <span>Share across organisation (Global)</span>
          </label>
          <p className="form-help-text">
            When enabled, this context variable will be visible to all users in your organisation.
          </p>
        </div>
      )}

      <div className="form-actions">
        <Button
          type="submit"
          variant="primary"
          className="add-context-variable-submit-button"
        >
          Save
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default ContextVariableForm;

